<div class="layer-content">
  <ng-content />

  @if (viewerOptions().mode === 'selection') {
    <mat-checkbox
      [checked]="selected()"
      [disabled]="selectionDisabled()"
      (change)="handleSelect($event)"
    />
  }
  <span class="igo-layer-title" (click)="handleExpand()">{{
    layer().title
  }}</span>
</div>

<div class="list-actions">
  <div class="list-secondary-actions">
    <button
      class="actions-button"
      tooltip-position="below"
      matTooltipShowDelay="500"
      [matTooltip]="'igo.geo.layer.group.moreOptions' | translate"
      mat-icon-button
      color="primary"
      (click)="toggleLayerGroupTool($event)"
    >
      <mat-icon>more_horiz</mat-icon>
    </button>
  </div>

  <igo-layer-visibility-button
    [layer]="layer()"
    [disabled]="isDisabled"
    [tooltip]="tooltipMessage"
    [inResolutionsRange]="layer().isInResolutionsRange$ | async"
    (visibilityChange)="toggleVisibility($event)"
  />
</div>
